import { Arrow } from './icons';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';

/**
 * The tenant root when the full site is turned off (full_site_enabled=False).
 * Deliberately spare — no CMS pages, no coverage map, no photo grid — but still
 * OCEN's real chrome and voice: same header/footer as TenantSite, same
 * burgundy-and-gold theme (ocen.css), same "give/apply" framing as the real
 * Hero. The /donate and /apply routes still resolve directly and carry their
 * own Section 25F prelaunch gate; this page just sets that expectation up
 * front rather than promising a live gift or an open application.
 */
export default function MinimalLanding() {
  return (
    <div className="site-minimal" data-testid="tenant-minimal-landing">
      <SiteHeader />
      <section className="hero-a">
        <div className="wrap" style={{ textAlign: 'center' }}>
          <div className="eyebrow-row" style={{ justifyContent: 'center' }}>
            <span className="bar"></span>
            <span className="eyebrow">A Pan-Orthodox Scholarship Fund</span>
            <span className="bar"></span>
          </div>
          <h1 style={{ margin: '0 auto 28px', maxWidth: 760 }}>
            An Orthodox school for <em>every Orthodox child</em> who seeks one.
          </h1>
          <p className="lede" style={{ maxWidth: 560, margin: '0 auto 36px' }}>
            OCEN raises and grants scholarships so the cost of tuition is never
            the reason a faithful family cannot send their child to a school of
            the Church.
          </p>
          <div className="ctas" style={{ justifyContent: 'center', marginBottom: 20 }}>
            <a href="/apply" className="btn btn-primary" data-testid="minimal-apply-link">
              Apply for a scholarship <Arrow />
            </a>
            <a href="/donate" className="btn btn-gold" data-testid="minimal-donate-link">
              Give today <Arrow />
            </a>
          </div>
          <p className="lede" style={{ maxWidth: 480, margin: '0 auto', fontSize: 15 }}>
            Section 25F, the federal scholarship tax credit, opens January 1,
            2027 — giving and applications both start then.
          </p>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
